import {Tab, TabsNavigation, Text} from '@/components-v2'
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'
import {useState} from 'react'
import {useSelector} from 'react-redux'
import {ComboListTabContent} from './ComboListTabContent'
import {ProductListTabContent} from './ProductListTabContent/ProductListTabContent'

const PRODUCT_LIST_TABS = [
  {label: 'Product List', component: ProductListTabContent, icon: 'storefront'},
  {label: 'Combo List', component: ComboListTabContent, icon: 'person'},
]

export const ProductListPage = () => {
  const countryCode = useSelector(selectCountryCode)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const allowedCountries = useFeatureValue(growthBookFeatureFlags.AllowedCountriesForComboList)?.allowedCountriesList ?? [
    'MX',
    'US',
  ]
  const tabs = allowedCountries.includes(countryCode ?? 'MX')
    ? PRODUCT_LIST_TABS
    : PRODUCT_LIST_TABS.filter(tab => tab.label !== 'Combo List')
  const activeTabIndex = Math.min(selectedTabIndex, tabs.length - 1)
  const SelectedTabComponent = tabs[activeTabIndex]?.component ?? ProductListTabContent

  return (
    <div className="flex flex-col gap-6" data-testid="new-theme-product-list-page">
      <Text headingLevel={4}>Products</Text>
      <TabsNavigation selectedIndex={activeTabIndex} onUpdate={setSelectedTabIndex}>
        {tabs.map(({label, icon}) => (
          <Tab key={label} label={label} iconLeading={icon} />
        ))}
      </TabsNavigation>
      <SelectedTabComponent />
    </div>
  )
}
